module.exports = __webpack_public_path__ + "logo_Take-away_2-0125f667815b7ebaf85c7ca9566931a2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo_Take-away_2.png
// module id = 1372
// module chunks = 1